isEmailSettings